import React from "react";
import { useState } from "react";
import { Checkbox, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

export default function TermsCheckbox({ onChange }) {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);

  const handleChange = (value) => {
    setChecked(value);
    onChange?.(value);
  };

  return (
    <Checkbox
      checked={checked}
      onChange={(e) => handleChange(e.currentTarget.checked)}
      label={
        <Text size="sm">
          {t("terms.agree")}{" "}
          <a
            href="https://www.playsafelysports.com/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("terms.link")}
          </a>
        </Text>
      }
      required
      mt="md"
    />
  );
}
